import React from "react";
import Table from "../../../../../../components/Common/Table";
import { View } from "../../../../../../components/Common/react-native-components";


const TableView = ({ tableData, lowSampleSize, customRowFormatter }) => {
    return (
        <View style={{ height: 'auto' }}>
            <Table table_data={tableData} lowSampleSize={lowSampleSize} expendable={false} customRowFormatter={customRowFormatter} />
        </View>
    );
};

export default TableView